import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import { filter } from "underscore";

const DropdownCompanies = ({
  closeDropdown,
  selected,
  onCompanySelected,
  companies = [],
  name,
  label = "",
}) => {
  const [list, setList] = useState(companies);
  const [searchTerm, setSearch] = useState("");

  useEffect(() => {
    setList(companies);
  }, [companies]);

  const handleSelect = (selectedItem) => {
    closeDropdown();
    onCompanySelected(selectedItem);
  };

  const handleSearch = (e) => {
    const value = e.target.value || "";
    setSearch(value);

    if (!value.trim()) {
      setList(companies);
      return;
    } else {
      const term = value.toUpperCase();

      const filtered = companies.filter((item) => {
        const name = (item?.name || "").toUpperCase();
        const id = String(item?.id || "").toUpperCase();
        return name.includes(term) || id.includes(term);
      });

      if (filter?.length === 0) {
        setList({ name: "Select", id: "" });
      } else {
        setList(filtered);
      }
    }
  };

  return (
    <DropdownWrapper>
      <SearchInput
        type="text"
        placeholder="Search by name or ID..."
        value={searchTerm}
        onChange={handleSearch}
      />
      <DropdownList>
        {list?.length > 0 ? (
          list?.map((item, idx) => (
            <DropdownItem
              selected={item.id === selected}
              key={item.id + idx}
              onClick={() =>
                handleSelect({
                  target: { value: item.id, name },
                })
              }
            >
              {item.name} {item?.id && <>({item?.id})</>}
            </DropdownItem>
          ))
        ) : (
          <NoResults>No {label} found</NoResults>
        )}
      </DropdownList>
    </DropdownWrapper>
  );
};

export default DropdownCompanies;

// Styled Components
const DropdownWrapper = styled.div``;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 4px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  outline: none;

  &:focus {
    // border-color: ${Colors.prussianBlue};
    outline: none;
  }
`;

const DropdownList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const DropdownItem = styled.div`
  padding: 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  background: ${(props) =>
    props.selected ? Colors.prussianBlue : Colors.white};

  &:hover {
    background-color: ${(props) =>
      props.selected ? Colors.prussianBlue : "#f0f0f0"};
    color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  }
`;

const NoResults = styled.div`
  padding: 12px;
  text-align: center;
  font-size: 0.85rem;
  color: #888;
`;
